export default __webpack_public_path__ + "static/notifications-screen-7d9886e7c882265077c64328500e6b85.webp";